"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_window_1 = require("react-window");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const memoize_one_1 = __importDefault(require("memoize-one"));
const Label_1 = __importDefault(require("../Label"));
const styled_1 = require("./styled");
const Row = (0, react_1.memo)(({ data, index, style, }) => {
    const option = data.options[index];
    return (react_1.default.createElement("div", { style: { height: `${data.itemHeight}px` } },
        react_1.default.createElement(styled_1.Option, { style: style, onClick: () => {
                var _a;
                data.onSelect(option.value);
                (_a = data.close) === null || _a === void 0 ? void 0 : _a.call(data);
            } }, option.content(false))));
}, react_window_1.areEqual);
const createItemData = (0, memoize_one_1.default)((options, onSelect, itemHeight, close) => ({
    options,
    onSelect,
    itemHeight,
    close,
}));
const VirtualizedList = ({ options, itemHeight, optionsTitle, onSelect, close, }) => {
    const itemData = createItemData(options, onSelect, itemHeight, close);
    return (react_1.default.createElement(styled_1.OptionsWrapper, null,
        typeof optionsTitle === 'string' ? (react_1.default.createElement(Label_1.default, { secondary: true }, optionsTitle)) : (optionsTitle),
        react_1.default.createElement(react_virtualized_auto_sizer_1.default, null, ({ height, width }) => (react_1.default.createElement(react_window_1.FixedSizeList, { innerElementType: "div", height: height, width: width, itemCount: options.length, itemSize: itemHeight, itemData: itemData }, Row)))));
};
exports.default = VirtualizedList;
//# sourceMappingURL=VirtualizedList.js.map